export const NO_EXTERNAL_CONNECTION_TEXT = "No external connection";
export const IP_VERSIONS = [4, 6];
